import React from "react";
import { Outlet } from "react-router-dom";

function ProductOutlet() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default ProductOutlet;
